export const SET_LEAD_APPROVE = 'SET_LEAD_APPROVE';
export const SET_LEAD_APPROVE_SUCCESS = 'SET_LEAD_APPROVE_SUCCESS';
export const SET_LEAD_APPROVE_FAILURE = 'SET_LEAD_APPROVE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_approval/redux/constants/set_lead_approve.constants.js